export default __webpack_public_path__ + "static/media/SUPERIOR.236f9163.jpg";